// Messages for portal/shell/CompanySwitcher (auto-merged by lib/i18n.ts).
export const en = {
  'portal.company_switcher.active_company': 'Active company',
  'portal.company_switcher.signed_in_as': 'Signed in as',
  'portal.company_switcher.your_companies': 'Your companies · {count}',
}

export const zhTW = {
  'portal.company_switcher.active_company': '目前公司',
  'portal.company_switcher.signed_in_as': '登入身分',
  'portal.company_switcher.your_companies': '您的公司 · {count}',
}
